/**
 * Shared feedback helpers for PostHog surveys.
 * Used by the floating FeedbackButton and the sidebar help menu "Give feedback" item.
 */
import posthog, { DisplaySurveyType, SurveyPosition } from "posthog-js";

import { ANALYTICS_EVENTS } from "@/lib/analytics/events";

const FEEDBACK_SURVEY_ID = process.env.NEXT_PUBLIC_POSTHOG_SURVEY_ID;

export interface OpenPostHogFeedbackOptions {
  /** Position of the survey popover (e.g. "left" for sidebar, default is right). */
  position?: "left" | "right";
}

/**
 * Opens the PostHog feedback survey popover. No-op (with a warning) when PostHog
 * is not loaded or the survey ID is unset.
 */
export function openPostHogFeedback(options?: OpenPostHogFeedbackOptions): void {
  if (!FEEDBACK_SURVEY_ID) {
    console.warn("[Feedback] NEXT_PUBLIC_POSTHOG_SURVEY_ID not set");
    return;
  }
  if (!posthog.__loaded) {
    console.warn("[Feedback] PostHog not loaded");
    return;
  }
  posthog.capture(ANALYTICS_EVENTS.FEEDBACK_BUTTON_CLICKED);
  const displayOptions: Parameters<typeof posthog.displaySurvey>[1] = {
    displayType: DisplaySurveyType.Popover,
    ignoreConditions: true,
    ignoreDelay: true,
    ...(options?.position !== undefined && {
      position: options.position as SurveyPosition,
    }),
  };
  // Force-fetch surveys so displaySurvey has the data it needs
  posthog.getSurveys((surveys) => {
    console.debug("[Feedback] surveys:", surveys.map((s) => ({ id: s.id, name: s.name })), "looking for:", FEEDBACK_SURVEY_ID);
    posthog.displaySurvey(FEEDBACK_SURVEY_ID, displayOptions);
  }, true);
}
